// extracted by css-extract-rspack-plugin
module.exports =  {"header":"DetailsHeader__header___D7kw5"};